// extracted by mini-css-extract-plugin
module.exports = {"container":"QuestionCard_container__YoWbj","answer":"QuestionCard_answer__2a4Xx"};